module.exports = __webpack_public_path__ + "static/media/zbigniew-sznajder.3e115e31.jpg";